import { usePJStore } from '@jaf/jaf-react-core';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { PJButton } from '@it-polimi/pj-react-ui';

function SearchBox(props) {

  const [searchText, setSearchText] = useState("");
  const getText = usePJStore((state) => state.i18n_getText)


  const [cont, setCont] = useState(props.textChangeTrigger);

  useEffect(() => {
    props.onTextChanged(searchText);
  }, [searchText]);

  useEffect(() => {
    props.onTextChanged(searchText);
  }, [cont]);

  useEffect(() => {
    props.onTextChanged("")
    setSearchText("")
  }, [props.clearTextTrigger]);

  useEffect(() => {
    if (props.textChangeTrigger > cont) {
      setCont(props.textChangeTrigger)
    }
  }, [props.textChangeTrigger]);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
      <h3 style={{ textAlign: "left", paddingLeft: "0.5rem" }}>Cerca tra tutte le FAQ:</h3>
      <div id="searchbox" className="sticky col-12 md:col-3" style={{ textAlign: "left" }}>

        <span className="p-input-icon-right" style={{ fontSize: '2rem', width: "100%" }}>
          <InputText value={searchText} placeholder={getText("WHAT_ARE_YOU_LOOKING_FOR")} style={{ width: "100%" }} onChange={(e) => setSearchText(e.target.value)} />
        </span>
        <div style={{ alignContent: 'center' }} >
          <PJButton icon="pmi-line pmi-12 pmi-line-arrow-right" className='p-button-text' />
        </div>
      </div >
    </div>
  )
}

export default SearchBox
